import { useTranslation } from 'react-i18next';

import { IndicatorStep } from './IndicatorStep';
import { GotoWorkflowTranscriptComponent } from './types';
import { ColorMode } from 'src/components/app/types';
import { IntentPredictionMessage } from 'src/pages/workflow-builder-preview/voice-preview/inbound-preview/info-console/PreviewExecutionMessage';

export const GotoWorkflow = ({
  theme,
  transcriptComponent,
}: {
  theme?: ColorMode;
  transcriptComponent: GotoWorkflowTranscriptComponent;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const title = transcriptComponent.intent_title
    ? transcriptComponent.intent_title
    : transcriptComponent.intent_workflow_id;

  return theme === 'dark' ? (
    <IntentPredictionMessage
      payload={{ intent: title, type: 'intent_prediction' }}
    />
  ) : (
    <IndicatorStep message={t('gotoWorkflow.message', { title })} />
  );
};
